<template>
  <Content
    :class="['collections-list-content', !$route.path.includes('analytics') && 'not-overflow-list']"
    :hide_alert="true"
  >
    <div class="collections">
      <Loading v-if="is_loading" class="static" />

      <div class="header" v-show="!is_loading && is_cre">
        <div class="right">
          <h3>All {{ typeTitle }}s&nbsp;({{ data_total }})</h3>
          <DatePicker :key="date_key" @update-date="updateDate" :date_range="date_range" ref="date_picker" />
          <CollectionFilterDropdown
            :params="filterParams"
            :disabled="table"
            @update-filter="updateFilter"
            :theType="the_type"
            :hide_creator="true"
          />
          <Dropdown
            v-if="!is_loading"
            :items="sort_select"
            :direction_type="'right'"
            :icon="'filter'"
            :default_value="sort_index"
            @update-dropdown="updateSort"
            :key="drop_key"
          />
          <el-button
            class="the-curated-btn"
            @click="ClickCurated"
            v-if="
              now_merchant.is_enable_storefront_curation &&
              (the_type === 'product' || the_type === 'collection')
            "
          >
            <Checkbox size="small" :checked="curated_check" />
            Curated only
          </el-button>
          <EditingList :data="data" v-if="collectionPermission === 100">
            <el-button
              type="primary"
              :disabled="
                data.every((e) => {
                  return !e.is_selected;
                })
              "
              >Edit</el-button
            >
          </EditingList>

          <Pagenavi
            :disabled="data.length === 0"
            :page_current="sort.page"
            :page_total="sort.total_page"
            @goto-page="gotoPage"
          />
        </div>
      </div>
      <!-- item.curation_id > 0  -->
      <div class="header is_cre-header" v-show="!is_loading && !is_cre">
        <!-- <h2>All Storefront {{ typeTitle }}s&nbsp;({{ data_total }}) </h2> -->
        <div class="flex-box" style="width: 100%">
          <div class="middle">
            <Search
              @onenter="search"
              @update="getSearchVal"
              :disabled="is_disabled"
              :placeholder_text="`Search by creator name, title or caption`"
            />
          </div>

          <div class="right">
            <CollectionFilterDropdown
              :params="filterParams"
              :disabled="table"
              @update-filter="updateFilter"
              :theType="the_type"
              :key="filterKey"
            />

            <Dropdown
              v-if="!is_loading"
              :items="sort_select"
              :direction_type="'right'"
              :icon="'filter'"
              :default_value="sort_index"
              @update-dropdown="updateSort"
              :key="drop_key"
              @is-open="handleOpenDrop"
              :type="'sort'"
              :handle_open_value="handle_open_value.sort"
              :disabled="is_disabled"
              :spec_drop_filed="'collection_sort_open'"
            />

            <el-button
              class="the-curated-btn"
              @click="ClickCurated"
              v-if="
                now_merchant.is_enable_storefront_curation  &&
                (the_type === 'product' || the_type === 'collection')
              "
            >
              <Checkbox size="small" :checked="curated_check" />
              Curated only
            </el-button>
            <Pagenavi
              :disabled="is_disabled"
              :page_current="sort.page"
              :page_total="sort.total_page"
              @goto-page="gotoPage"
            />

            <EditingList :data="data" v-if="collectionPermission === 100">
              <el-button
                type="primary"
                :disabled="
                  data.every((e) => {
                    return !e.is_selected;
                  })
                "
                >Edit</el-button
              >
            </EditingList>
          </div>
        </div>
      </div>

      <CollectionFilterResults
        :params="filterParams"
        :theType="the_type"
        v-if="!is_disabled && isFilter"
        @update-filter="updateFilter"
        v-show="!is_loading"
        :key="filterKey"
      />

      <!-- list -->
      <div class="inner" v-show="!is_loading">
        <div :class="['data-wrap', data.length === 0 && 'data-wrap-no-border']">
          <Scrollbar class="data-list" :show_bar="true">
            <NoData
              v-if="is_disabled"
              :image="require('@/assets/images/data.png')"
              :title="''"
              :text="
                !is_cre
                  ? `Creators has not made any ${typeTitle}s yet.`
                  : `This creator hasn’t created any ${typeTitle}s yet.`
              "
            />
            <Table v-else>
              <template #head>
                <tr>
                  <th class="sitcky-td" v-if="collectionPermission === 100">
                    <span :key="is_selected">
                      <Checkbox :checked="is_selected" @click="allSelect()" />
                    </span>
                  </th>
                  <th :class="['title sitcky-td sitcky-td2', !collectionPermission && 'sitcky-td2-2']">
                    <span>{{ typeTitle }}</span>
                  </th>

                  <!--9671-->
                  <th class="thir-td"><span>Status</span></th>
                  <th v-if="!is_cre"><span>Owner</span></th>

                  <th>
                    <CollectionTh
                      :name="'views'"
                      :title="`Views`"
                      :sort_value="sort"
                      @sort="sortFun"
                      :content="`The number of views of a ${typeTitle} cover during the time period selected.`"
                    />
                  </th>
                  <th>
                    <CollectionTh
                      :name="`visit`"
                      :title="`Visits`"
                      :sort_value="sort"
                      @sort="sortFun"
                      :content="`Total number of clicks to visit a ${typeTitle} during the time period selected.`"
                    />
                  </th>
                  <th>
                    <CollectionTh
                      :name="'product_click'"
                      :title="'Product Clicks'"
                      :sort_value="sort"
                      @sort="sortFun"
                      :content="`Cumulative link clicks on products in the ${typeTitle} during the time period selected.`"
                    />
                  </th>
                  <th>
                    <CollectionTh
                      :name="`sales`"
                      :title="`Sales`"
                      :sort_value="sort"
                      @sort="sortFun"
                      :content="`Total number of sales driven by the ${typeTitle} during the time period selected.`"
                    />
                  </th>
                  <th>
                    <CollectionTh
                      :name="`sales_value`"
                      :title="`Sales Value`"
                      :sort_value="sort"
                      :content="`Gross transaction value driven by the ${typeTitle} during the time period selected.`"
                      @sort="sortFun"
                    />
                  </th>

                  <!--new 9671-->
                  <th>
                    <CollectionTh
                      :name="'created_at'"
                      :title="'Date Added'"
                      :sort_value="sort"
                      :content="'Date Added'"
                      @sort="sortFun"
                    />
                  </th>
                  <th>
                    <CollectionTh
                      :name="'updated_at'"
                      :title="'Last Updates'"
                      :sort_value="sort"
                      :content="'Last Updates'"
                      @sort="sortFun"
                    />
                  </th>

                  <th>
                    <CollectionTh
                      :name="'flag'"
                      :title="'Flag Level'"
                      :sort_value="sort"
                      :content="'Flag Level'"
                      @sort="sortFun"
                    />
                  </th>
                </tr>
              </template>

              <template #body>
                <template v-if="!is_loading && data.length === 0 && this.isFilter">
                  <tr>
                    <td colspan="13">
                      <NoData />
                    </td>
                  </tr>
                </template>

                <tr
                  v-else
                  v-for="(row, index) in data"
                  :key="index"
                  :class="{ selected: row.is_selected }"
                  @click.stop="open(row, 'isClick')"
                >
                  <td class="sitcky-td" v-if="collectionPermission === 100" @click.stop="handleSelect(index)">
                    <Checkbox :checked="row.is_selected" :disabled="row.can_not_edit || row.curation_id > 0" />
                  </td>

                  <td :class="['title sitcky-td sitcky-td2', !collectionPermission && 'sitcky-td2-2']">
                    <div class="title-content">
                      <collection-images :image="row.cover_image_url" :images="row.first_4_product_thumbnails" />

                      <div class="middle">
                        <div class="collect-name-box">
                          <div class="collect-name" v-tippy="{ content: row.name, delay: [500, 20] }">
                            {{ row.name }}
                          </div>
                          <div class="curated-label" v-if="row.curation_id">Curated collection</div>
                          <div class="desc">{{ row.description }}</div>
                        </div>

                        <div class="bottom-line-box">
                          <div class="badage-box">
                            <Badage
                              v-for="(v, k) in row.badage"
                              :key="k"
                              :value="v.name"
                              v-show="!v.is_feature"
                              :type="v.color"
                            />
                          </div>
                          <div class="shop"><SvgIcon name="bag" />{{ row.product_count ? row.product_count : 0 }}</div>
                          <i
                            class="icon-box"
                            v-if="
                              row.flag.icon &&
                              !row.curation_id &&
                              (!row.can_not_edit || (row.can_not_edit && row.flag.color !== 'normal')) &&
                              (collectionPermission === 100 || row.flag.icon === 'flag-color')
                            "
                            ><svg-icon :class="[`svg-flag-${row.flag.color}`]" :name="row.flag.icon"
                          /></i>
                          <div @click.stop>
                            <EditingList
                              :row="row"
                              v-if="!row.can_not_edit && collectionPermission === 100"
                              :is_published="!row.is_disabled && !row.is_hidden && !row.is_archvied"
                            >
                              <i class="icon-box"><svg-icon name="circle-menu" /></i>
                            </EditingList>
                          </div>
                        </div>
                      </div>
                      <div class="right" @click.stop="goOutside(row)">
                        <SvgIcon name="go-out" v-if="row.is_publish && !row.can_not_edit" />
                      </div>
                    </div>
                  </td>

                  <!--9671-->
                  <td class="thir-td">
                    <div class="badage-flex">
                      <div v-if="row.curation_id && row.is_publish === 0" class="select-as-button select-as-button-spec">
                        <div class="active-btn btn-red">
                          <div class="flex-box">
                            <p>Inactive</p>
                          </div>
                        </div>
                      </div>
                      <div v-else class="select-as-button select-as-button-spec" @click.stop="openStatusSelect(index, row)">
                        <div :class="['active-btn', !row.can_not_edit && 'disabled-btn', `btn-${row.status.color}`]">
                          <div class="flex-box">
                            <svg-icon
                              name="arrow"
                              v-if="!row.can_not_edit && collectionPermission === 100 && !row.curation_id"
                            />
                            <p>{{ row.status.name }}</p>
                          </div>
                        </div>

                        <el-select
                          ref="hiddenStatusSelect"
                          default-first-option
                          :reserve-keyword="false"
                          @change="(val) => StatusSelect(val, row)"
                        >
                          <el-option
                            v-for="(item, k) in statusChnageList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value"
                            :class="[
                              'option-item-in-status',
                              cantNotClick(item.value, row) && 'disabled-status-option',
                            ]"
                          >
                            <span>{{ item.name }}</span>
                            <svg-icon
                              style="width: 12px; height: 12px"
                              v-if="cantNotClick(item.value, row)"
                              name="yes-2"
                            />
                          </el-option>
                        </el-select>
                      </div>
                      <Badage v-if="row.is_feature" :value="'Featured'" :type="'yellow'" />
                    </div>

                    <p v-if="row.is_active && row.is_publish !== 0" style="margin-top: 4px">In storefront</p>
                    <p v-else style="margin-top: 4px">
                      {{
                        row.deleted_at
                          ? $filters.momentFormat(row.deleted_at, 'll')
                          : $filters.momentFormat(row.updated_at, 'll')
                      }}
                    </p>
                  </td>

                  <td class="cre-name-box" v-if="!is_cre">
                    <div class="collect-cre-box">
                      <figure class="img-box">
                        <img :src="row.userProfile.avatar_full_url" :alt="row.user_name" @error="imageError($event)" />
                      </figure>
                      <div class="collect-name" v-tippy="{ content: row.user_name, delay: [500, 20] }">
                        {{ row.user_name }}
                      </div>
                    </div>
                    <tippy
                      :delay="[0, 20]"
                      class="storefront-state"
                      :class="['class-' + row.anchor_creator.anchor_page_status]"
                      :key="row.anchor_creator.anchor_page_status"
                    >
                      {{ row.anchor_creator.anchor_page_status_text }}
                    </tippy>
                  </td>

                  <td class="number">
                    <div class="value">
                      <span>{{ row.views }}</span>
                    </div>
                  </td>
                  <td class="number">
                    <div class="value">
                      <span>{{ row.visit }}</span>
                    </div>
                  </td>
                  <td class="number">
                    <div class="value">
                      <span>{{ row.product_click }}</span>
                    </div>
                  </td>
                  <td class="number">
                    <div class="value">
                      <span>{{ row.sales }}</span>
                    </div>
                  </td>
                  <td class="number">
                    <div class="value">
                      <span>{{ row.sales_value }}</span>
                    </div>
                  </td>

                  <!--9671-->
                  <td :key="row.created_at">
                    <span>{{ row.created_at }}</span>
                    <br /><span class="small-alert" v-if="!row.contentModertaion.is_read">New</span>
                  </td>
                  <td :key="row.updated_at">
                    <span>{{ row.updated_at }}</span>
                  </td>
                  <td>
                    <span :class="[`text-color-${row.flag.color}`]">{{
                      row.contentModertaion.flag_status_name ? row.contentModertaion.flag_status_name : 'N/A'
                    }}</span>
                  </td>
                </tr>

                <td colspan="13" v-if="is_next_loading || is_loading">
                  <Loading class="static" />
                </td>
              </template>

              <!-- <template #foot v-if="!is_loading && data.length !== 0">
                                    <tr>
                                        <td class="sitcky-td sitcky-td-tfoot" :colspan="2">
                                            Total(3)
                                        </td>
                                        <td :colspan="2"></td>
                                        <td>3333</td>
                                        <td>4444</td>
                                        <td>5555</td>
                                        <td>6666</td>
                                        <td>777</td>
                                        <td colspan="2"></td>
                                    </tr>
                                </template> -->
            </Table>
          </Scrollbar>
        </div>
      </div>
    </div>
  </Content>
</template>

<script>
import Content from '@/components/ui/Content.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Table from '@/components/ui/Table.vue';
import SvgIcon from '@/components/ui/SvgIcon.vue';
import Loading from '@/components/ui/Loading.vue';
import NoData from '@/components/creator/NoData.vue';
import moment from 'moment';
import Layout from '@/components/creator/CollectionImage.vue';
import DatePicker from '@/components/ui/DatePicker.vue';
import CollectionProduct from '@/components/creator/CollectionProduct.vue';
import Badage from '@/components/ui/Badage.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import CollectionTh from '@/components/creator/CollectionProductTh.vue';
import Search from '@/components/ui/Search.vue';
import Pagenavi from '@/components/ui/Pagenavi.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import { ElSelect, ElOption, ElMenu, ElMenuItem, ElSubMenu, ElButton, ElDialog, ElInput, ElStep } from 'element-plus';
import EditingList from '@/components/creator/CollectionTemplate/CollectionEditList.vue';
import CollectionFilterDropdown from '@/components/creator/CollectionTemplate/CollectionFilterDropdown.vue';
import CollectionFilterResults from '@/components/creator/CollectionTemplate/CollectionFilterResults.vue';
import { useCollectionFilter } from '@/components/creator/collectionFilterFunction.js';
import CollectionImages from '../ui/CollectionImages.vue';

import {
  Sort_select_coll_list,
  Sort_select_post_list,
  SwitchSort,
  ImageError,
  HandleNum,
  HandleName,
  handleMoney,
  PickSortIndex,
  makeCollectionIcon,
} from '@/utils/SwitchFun';

const { statusList, typeList, flagList, creatorStausList, makeCollectionBadage, makeCollectionItem, callApiTypeId } =
  useCollectionFilter();
export default {
  name: 'Collections-List',

  data() {
    return {
      is_loading: true,
      date_key: 0,
      start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
      end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
      data: [],
      data_total: 0,
      sort: {
        sort_key: 'views',
        sort_val: 'desc',
        page: 1,
        per_page: 50,
        total_page: 1,
      },
      sort_select: Sort_select_coll_list,
      sort_index: 0,
      drop_key: 0,
      drop_type_key: 0,
      is_end: false,
      is_next_loading: false,
      drop_open: {
        type: false,
        status: false,
        sort: false,
      },
      //9761 new
      filterParams: {
        status: 0,
        type: 0,
        flag: 0,
        anchor_status: 0,
        keyword: '',
        brands: [],
      },
      filterKey: 0,
      remberRow: null,
      statusChnageList: [
        { name: 'Active', value: 1 },
        { name: 'Disable', value: 2 },
      ],
      curated_check: false,
    };
  },

  props: {
    date_range: {
      type: Object,
      default: null,
    },
    data_info: {
      type: Object,
      default: null,
    },
    is_show_hint: {
      type: Boolean,
      default: false,
    },
    the_type: {
      type: String,
      default: 'collection',
      // collection, post
    },
    is_creator: {
      type: Boolean,
      default: false,
    },
    selected_creator_tags: {
      type: Array,
      default: () => [],
    },
    creator_tag_operation_type: {
      type: String,
      default: 'or',
    },
  },

  computed: {
    typeTitle() {
      if (this.the_type === 'collection') {
        return 'Collection';
      } else if (this.the_type === 'post') {
        return 'Post';
      }
      return '';
    },
  },

  components: {
    Content,
    Scrollbar,
    Table,
    NoData,
    Loading,
    SvgIcon,
    Layout,
    DatePicker,
    CollectionProduct,
    Badage,
    Dropdown,
    CollectionTh,
    Search,
    Pagenavi,
    Checkbox,
    ElSelect,
    ElOption,
    ElMenu,
    ElMenuItem,
    ElSubMenu,
    EditingList,
    CollectionFilterDropdown,
    CollectionFilterResults,
    CollectionImages,
    ElButton,
  },

  watch: {
    '$route.params': {
      handler() {
        this.data = [];
        this.is_loading = true;
      },
      immediate: true,
    },
  },

  computed: {
    is_cre() {
      return this.data_info && this.data_info.id;
    },

    handle_open_value() {
      return {
        type: this.drop_open.sort || this.drop_open.status,
        status: this.drop_open.type || this.drop_open.sort,
        sort: this.drop_open.type || this.drop_open.status,
      };
    },

    isFilter() {
      return (
        this.filterParams.keyword ||
        this.filterParams.status ||
        this.filterParams.type ||
        this.filterParams.flag ||
        this.filterParams.anchor_status
      );
    },

    is_disabled() {
      return this.data.length === 0 && !this.isFilter && !this.is_loading;
    },

    typeTitle() {
      if (this.the_type === 'collection') {
        return 'Collection';
      } else if (this.the_type === 'post') {
        return 'Post';
      }
      return '';
    },
    collectionPermission() {
      //50 can view /0 can not view/100 all can view can edit
      return this.$store.state.user_data.permission_list?.contentModeration?.contentModeration?.permission;
    },
    //only collectionPermission now
    // disabledPermission(){
    //     return  this.$store.state.user_data.permission_list?.contentModeration?.canDisableContent?.permission;
    // },

    // flagPermission(){
    //     return  this.$store.state.user_data.permission_list?.contentModeration?.canFlagContent?.permission;
    // },
    now_merchant() {
      return this.$store.state.user_data.merchant_account;
    },
  },

  methods: {
    open(row, isClick) {
      const currentIndex = this.data.findIndex((item) => item.id === row.id);
      const hasPrev = currentIndex > 0 || this.sort.page > 1;
      const hasNext = currentIndex < this.data.length - 1 || this.sort.page < this.sort.total_page;

      const urlParams = new URLSearchParams(window.location.search);
      if (!urlParams.get('content_id')) {
        // use history api add id to url
        const url = new URL(window.location);
        url.searchParams.set('content_id', row.id);
        window.history.replaceState(null, '', url.toString());
      }

      if (isClick) {
        window.localStorage.setItem('handleRowDataFromCollection', JSON.stringify(row));
      }

      this.EventBus.emit('open-collect-product-modal', {
        data: row,
        data_info: this.data_info,
        date_range: this.date_range,
        is_show_hint: this.is_show_hint,
        is_creator: this.is_creator,
        hasPrev,
        hasNext,
      });
      this.remberRow = row;

      //change is_read
      if (!row.contentModertaion.is_read) {
        row.contentModertaion.is_read = 1;
      }
    },

    imageError: ImageError,
    handleNum: HandleNum,
    handleName: HandleName,
    makeCollectionIcon: makeCollectionIcon,

    gotoPage(page) {
      this.sort.page = page;
      this.fetchData();
    },

    makeApiStr() {
      let filters = [];

      // console.log('this.filterParams', this.filterParams);

      if (this.filterParams.keyword) {
        filters.push({ field_name: 'keyword', value: this.filterParams.keyword });
      }

      if (this.filterParams.status) {
        let val = statusList.value[this.filterParams.status];
        filters.push({ field_name: val.field_name, value: val.keyword });
      }

      if (this.filterParams.type) {
        let val = typeList.value[this.filterParams.type];
        filters.push({ field_name: val.field_name, value: val.keyword });
      }

      if (this.filterParams.flag) {
        let val = flagList.value[this.filterParams.flag];
        filters.push({ field_name: val.field_name, value: val.keyword });
      }

      if (this.filterParams.anchor_status) {
        let val = creatorStausList.value[this.filterParams.anchor_status];
        filters.push({ field_name: val.field_name, value: val.keyword });
      }

      return JSON.stringify(filters);
    },

    async fetchData() {
      this.is_loading = true;

      const req_par = {
        start_date: this.date_range.start_date,
        end_date: this.date_range.end_date,
      };

      // console.log('this.data_info', this.data_info)

      if (this.data_info) {
        req_par.anchor_creator_id = this.data_info.id;
      }

      const params_data = {
        ...req_par,
        sort_key: this.sort.sort_key,
        sort_val: this.sort.sort_val,
        page: this.sort.page,
        per_page: this.sort.per_page,
        filters: this.makeApiStr(),
        type: this.the_type,
        is_include_curation_data: this.curated_check ? '1' : '0',
      };

      // Only add creator_tag_ids if we have tags (following project pattern)
      if (this.selected_creator_tags && this.selected_creator_tags.length > 0) {
        params_data.creator_tag_ids = this.selected_creator_tags.map((tag) => tag.id);
        params_data.operation_type = this.creator_tag_operation_type;
      }

      try {
        const res = await this.$ajax(`creator/get-collection-list`, {
          params: params_data,
          method: 'get',
        });

        res.data.data.data.forEach((item) => {
          item.created_at = this.$filters.momentFormat(item.created_at, 'll');
          item.updated_at = this.$filters.momentFormat(item.updated_at, 'll');
          item.views = this.handleNum(item.views);
          item.visit = this.handleNum(item.visit);
          item.product_click = this.handleNum(item.product_click);
          item.sales = this.handleNum(item.sales);
          item.sales_value = handleMoney(item.sales_value);
          item.cover_image_url = item.cover_image_url
            ? item.cover_image_url
            : !item.cover_image_url && item.first_4_product_thumbnails && item.first_4_product_thumbnails.length === 0
            ? item.default_cover_image_url
            : null;

          if (!item.userProfile) {
            item.userProfile = {
              avatar_full_url: require('@/assets/images/user.png'),
            };
          }

          if (item.anchor_creator) {
            item.user_name = `${item.anchor_creator.first_name} ${item.anchor_creator.last_name}`;
          }

          makeCollectionBadage(item, this);
          makeCollectionItem(item, this);
        });

        this.data = res.data.data.data;
        this.data_total = res.data.data.total;
        this.sort.total_page = res.data.data.last_page;
        this.is_end = res.data.data.current_page === res.data.data.last_page;

        const params = new URLSearchParams(window.location.search);
        const contentId = params.get('content_id');
        if ((this.the_type === 'collection' || this.the_type === 'post') && contentId) {
          const target = this.data.find((item) => item.id === parseInt(contentId));
          if (target) {
            this.open(target);
          } else {
            this.open(
              window.localStorage.getItem('handleRowDataFromCollection')
                ? JSON.parse(window.localStorage.getItem('handleRowDataFromCollection'))
                : this.data[0]
            );
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.is_loading = false;
        this.is_next_loading = false;
      }
    },

    updateSort(id) {
      let getVal = SwitchSort(id.id);
      this.sort.sort_key = getVal.key;
      this.sort.sort_val = getVal.val;
      this.sort.page = 1;

      this.sort_index = PickSortIndex(this.sort_select, this.sort.sort_key, this.sort.sort_val);
      this.drop_key += 1;
      this.fetchData();
    },

    sortFun(key) {
      if (key === this.sort.sort_key) {
        this.sort.sort_val = this.sort.sort_val === 'asc' ? 'desc' : 'asc';
      } else {
        this.sort.sort_key = key;
        this.sort.sort_val = 'asc';
      }

      //(sort the table can chnage dropdown)
      this.sort.page = 1;
      this.sort_index = PickSortIndex(this.sort_select, this.sort.sort_key, this.sort.sort_val);
      this.drop_key += 1;
      this.fetchData();
    },

    updateDate(obj) {
      this.$emit('update-creator-modal-date', obj);
    },

    goOutside(row) {
      if (row.is_publish && !row.deleted_at) {
        window.open(row.share_url, '_blank');
      }
    },

    search(keyword) {
      this.filterParams.keyword = keyword;
      console.log('this.filterParams', this.filterParams);
      this.sort.page = 1;
      this.fetchData();
    },

    getSearchVal(keyword) {
      this.filterParams.keyword = keyword;
    },

    handleOpenDrop(val) {
      this.drop_open[val.type] = val.value;
    },

    //9671 new
    openStatusSelect(index, row) {
      if (row.can_not_edit || this.collectionPermission !== 100 || row.curation_id > 0) {
        return;
      }
      const selectRefs = this.$refs.hiddenStatusSelect;
      const targetSelect = Array.isArray(selectRefs) ? selectRefs[index] : selectRefs;
      if (targetSelect) {
        targetSelect.toggleMenu(); // 正確開啟下拉
      }
    },

    cantNotClick(val, row) {
      return (val === 1 && row.is_active) || (val === 2 && (row.is_disabled || row.is_hidden || row.is_archvied));
    },

    StatusSelect(val, row) {
      console.log('val', val);
      if (this.cantNotClick(val, row)) {
        return;
      }
      if (val === 1) {
        this.EventBus.emit('open-collection-handle-dialog', { id: 2, rows: [{ ...row }], which: row.type });
      } else {
        this.EventBus.emit('open-collection-handle-dialog', { id: 1, rows: [{ ...row }], which: row.type });
      }
    },

    updateFilter(obj) {
      this.filterParams = obj;
      this.filterKey += 1;
      this.fetchData();
    },

    allSelect() {
      if (this.data.filter((i) => i.is_deleted || i.is_hidden || i.curation_id).length === this.data.length) {
        return;
      }
      this.is_selected = !this.is_selected;
      this.data.forEach((item) => {
        item.is_selected = !item.is_deleted && !item.is_hidden && !item.curation_id ? this.is_selected : false;
      });
    },

    checkSelect() {
      const visible = this.data.filter((i) => !i.is_deleted && !i.is_hidden && !i.curation_id);
      this.is_selected = visible.every((i) => i.is_selected);
    },

    handleSelect(index) {
      if (this.data[index].is_deleted || this.data[index].is_hidden || this.data[index].curation_id) {
        return;
      }
      this.data[index].is_selected = !this.data[index].is_selected;
      this.checkSelect();
    },

    forProductModalOutAndDown() {
      this.EventBus.on('get-prev-next-item', async ({ currentId, direction }) => {
        // 找當前索引
        const index = this.data.findIndex((row) => row.id === currentId);

        let targetRow = null;

        if (direction === 'prev') {
          if (index > 0) {
            // 同一頁上一筆
            targetRow = this.data[index - 1];
            if (targetRow) {
              this.data[index - 1].is_read = 1;
            }
          } else if (this.sort.page > 1) {
            // 需要跨頁
            this.sort.page--;
            await fetchData(); // 重新取得上一頁資料
            targetRow = this.data[tableData.length - 1];
            if (targetRow) {
              this.data[tableData.length - 1].is_read = 1;
            }
          }
        } else if (direction === 'next') {
          if (index < this.data.length - 1) {
            // 同一頁下一筆
            targetRow = this.data[index + 1];
            if (targetRow) {
              this.data[index + 1].is_read = 1;
            }
          } else if (this.sort.page < totalPages) {
            // 需要跨頁
            this.sort.page++;
            await fetchData(); // 重新取得下一頁資料
            targetRow = this.data[0];
            if (targetRow) {
              this.data[0].is_read = 1;
            }
          }
        }

        if (targetRow) {
          // 回傳給子層
          const currentIndex = this.data.findIndex((item) => item.id === targetRow.id);
          targetRow.hasPrev = currentIndex > 0 || this.sort.page > 1;
          targetRow.hasNext = currentIndex < this.data.length - 1 || this.sort.page < this.sort.total_page;
          targetRow.needRefrashTable = true;

          if (this.$route.query.content_id) {
            const url = new URL(window.location);
            url.searchParams.set('content_id', targetRow.id);
            window.history.replaceState(null, '', url.toString());
            window.localStorage.setItem('handleRowDataFromCollection', JSON.stringify(targetRow));
          }

          this.EventBus.emit('refrash-collection-product', targetRow);
        } else {
          // 已經沒有上一筆或下一筆了，可以回傳 disable 狀態
          this.EventBus.emit('no-more-prev-next', { direction });
        }
      });
    },

    ClickCurated() {
      this.curated_check = !this.curated_check;
      this.fetchData();
    },
  },

  async mounted() {
    this.sort_select = this.the_type === 'collection' ? Sort_select_coll_list : Sort_select_post_list;

    if (this.date_range) {
      this.date_key += 1;
      this.sort.page = 1;
      this.fetchData();
    }

    this.EventBus.on('refrash-collection-table', async () => {
      this.date_key += 1;
      await this.fetchData();
      // if(this.remberRow?.id){
      //     this.remberRow = this.data.filter(e => e.id === this.remberRow.id).length > 0 ? this.data.filter(e => e.id === this.remberRow.id)[0] : this.remberRow;
      //     this.EventBus.emit('refrash-collection-product', this.remberRow);
      // }
    });

    this.EventBus.on('get-product-close', () => {
      this.remberRow = null;
    });

    this.forProductModalOutAndDown();
  },

  beforeDestroy() {
    this.EventBus.off('refrash-collection-table');
    this.EventBus.off('get-prev-next-item');
    this.EventBus.off('get-product-close');
  },
};
</script>

<style lang="scss">
@mixin textOver() {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  display: block;
}

.collections-list-content {
  display: grid;
  grid-template-rows: auto auto 1fr;
  grid-template-columns: 100%;
  height: calc(100% - 16px);
  overflow: hidden;
  margin-top: 0px !important;
  border-radius: 0;

  &.not-overflow-list {
    overflow: unset;
    margin-top: 20px !important;

    .data-wrap {
      height: calc(100vh - 400px);
    }
  }

  .header {
    font: var(--font-demi-20);
    color: var(--black-90);
    display: flex;
    align-items: center;
    margin: 0 0 16px;

    h3 {
      flex: 1;
    }

    .right {
      display: flex;
      align-items: center;
      gap: 12px;
      width: 100%;

      h3 {
        flex: 1;
      }
    }

    &.is_cre-header {
      justify-content: space-between;
      gap: 20px;
      .right {
        width: unset;
      }

      .flex-box {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: calc(100% - 280px);
        gap: 12px;
      }

      h2 {
        font: var(--font-demi-20);
        color: var(--black-90);
        margin: 0;
        display: block;
      }

      .middle {
        flex: 1;

        .ui-search-input .input {
          max-width: unset;
        }
      }
    }
  }

  & > .inner {
    height: 100%;
    display: grid;
    grid-template-rows: auto 1fr;
    grid-template-columns: 100%;
    overflow: hidden;
  }

  .loading.static {
    margin-top: 48px;
    width: 100%;
  }

  .data-wrap {
    margin: 16px 0;
    border-top: 1px solid var(--border);
    // min-height: 600px;

    &.data-wrap-no-border {
      border: none;
    }

    .ui-table {
      white-space: nowrap;

      .svg-icon {
        width: 14px;
        height: 14px;
        cursor: pointer;
      }

      thead {
        top: 0;
        z-index: 10;
        background: var(--white);
      }

      th {
        color: var(--black-75);
        background-color: unset;

        .title-content {
          max-width: 380px;
          min-width: 380px;
        }

        .ico {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }

      td {
        color: var(--black-75);
        cursor: pointer;

        .small-alert {
          color: var(--red);
          font-size: 12px;
        }

        .title-content {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          max-width: 380px;
          min-width: 380px;
          overflow: hidden;

          .collection-grid {
            position: relative;
            width: 130px;
            height: 130px;
            min-width: 130px;
          }

          .img-box {
            position: relative;
            width: 130px;
            height: 130px;
            min-width: 130px;
            background-color: var(--bg-03);

            &.img-box-white {
              background-color: var(--bg-01);
            }

            .likeboard-layout-wrap {
              width: 100%;
              height: 100%;
              object-fit: contain;
              margin-right: 11px;
            }
          }

          .badage-box {
            display: flex;
            flex-wrap: wrap;
            width: 100%;

            .my-badges-iden {
              margin-right: 8px;
            }
          }

          .middle {
            overflow: hidden;
            width: calc(100% - 198px);
            font-weight: 400;
            color: var(--black-90);
            display: grid;
            grid-template-rows: auto 1fr;
            height: 130px;

            .collect-name-box {
              width: 100%;
              overflow: hidden;

              .desc {
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                font-size: 14px;
                white-space: initial;
              }
            }

            .collect-name {
              width: 100%;
              font: var(--font-demi-14);
              margin-right: 11px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              white-space: break-spaces;
            }

            .curated-label {
              margin: 6px 0;
              font-size: 12px;
              color: var(--black-75);
            }

            .bottom-line-box {
              display: flex;
              flex-wrap: wrap;
              align-items: center;
              align-content: flex-end;
              gap: 0px 12px;

              .el-dropdown {
                &:hover {
                  background-color: var(--black-20);
                }
              }

              .icon-box {
                width: 16px;
                height: 16px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;

                .svg-icon {
                  width: 14px;
                  height: 14px;
                  fill: var(--black-75);

                  &.svg-icon--flag-2,
                  &.svg-icon--flag-color {
                    width: 12px;
                    height: 12px;
                  }

                  &.flag-1 {
                    fill: var(--red);
                  }

                  &.flag-2 {
                    fill: var(--blue);
                  }

                  &.flag-3 {
                    fill: var(--yellow);
                  }
                }

                &.icon-box-yes {
                  svg {
                    fill: var(--green);
                  }
                }
              }
            }

            .shop {
              display: flex;
              align-items: center;
              margin: 8px 0px;
              font: var(--font-med-12);
            }

            .collect-date-box {
              font-size: 10px;
              margin-top: 6px;
              color: var(--black-75);
            }
          }

          .right {
            width: 14px;

            .svg-icon {
              color: var(--blue);
            }
          }
        }

        &.number {
          .value {
            display: flex;
            align-items: center;
          }

          .svg-icon {
            margin-left: 10px;
            fill: var(--green);

            &.down {
              fill: var(--red);
              transform: rotate(90deg);
            }
          }
        }
      }

      .sitcky-td {
        position: sticky;
        left: 0;
        z-index: 9;
        box-shadow: var(--bot-2dp);
        background-color: var(--white);
      }

      th.sitcky-td {
        border-bottom: solid 1px var(--border);
      }

      .sitcky-td2 {
        left: 36px !important;

        &::after {
          position: absolute;
          width: 10px;
          height: 100%;
          right: -10px;
          top: 0;
          content: '';
          background: linear-gradient(-90deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.1));
        }
      }

      .sitcky-td2-2 {
        left: 0 !important;
      }

      .sitcky-td-tfoot {
        background-color: var(--bg-10);

        &::after {
          position: absolute;
          width: 10px;
          height: 100%;
          right: -10px;
          top: 0;
          content: '';
          background: linear-gradient(-90deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.1));
        }
      }

      .thir-td {
        padding-left: 24px;

        .badage-flex {
          display: flex;
          gap: 6px;
        }
      }

      .img-icon {
        width: 18px;
        height: 18px;
        background-color: var(--white);
        border-radius: 8px 0 8px 0;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border: solid 1px var(--border);

        .svg-icon {
          width: 12px;
          height: 12px;
        }
      }

      .cre-name-box {
        max-width: 160px;

        .collect-cre-box {
          display: flex;
          align-items: center;

          .img-box {
            width: 24px;
            height: 24px;
            overflow: hidden;
            border-radius: 50%;
            margin-right: 6px;
            min-width: 24px;
            position: relative;

            img {
              object-fit: cover;
              width: 24px;
              height: 24px;
            }
          }
        }

        .storefront-state {
          margin-left: 30px;
        }
      }

      tfoot {
        z-index: 10;
      }

      .text-color-red {
        font-weight: bold;
        color: var(--red);
      }

      .text-color-yellow {
        font-weight: bold;
        color: var(--yellow);
      }

      .text-color-blue {
        font-weight: bold;
        color: var(--blue);
      }
    }
  }

  .select-as-button {
    .el-select__wrapper {
      height: 0;
      width: 0;
      position: absolute;
      top: -36px;
      padding: 0;
      opacity: 0;
    }

    .active-btn {
      color: var(--black-90);
      display: inline-block;
      font: var(--font-med-12);
      cursor: pointer;

      .flex-box {
        display: flex;
        padding: 4px 8px;
        align-items: center;
        gap: 4px;
      }

      svg {
        width: 8px !important;
        height: 8px !important;
      }

      &.btn-red {
        background-color: var(--bg-11);
      }
      &.btn-yellow {
        background-color: var(--light-yellow);
      }
      &.btn-green {
        background-color: var(--light-green);
      }
      &.btn-normal {
        background-color: var(--bg-02);
      }

      &.disabled-btn {
        cursor: not-allowed;
        pointer-events: none;
      }
    }
  }

  .the-curated-btn {
    border-color: var(--black-60);
    color: var(--black-60);
    font-size: 12px;
    padding-left: 9px;
    padding-right: 9px;
  }
}

.svg-flag-red {
  fill: var(--red) !important;
}

.svg-flag-blue {
  fill: var(--blue) !important;
}

.svg-flag-yellow {
  fill: var(--yellow) !important;
}

.option-item-in-status {
  display: flex;
  align-items: center;
  gap: 12px;

  &.disabled-status-option {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }
}
</style>
